import Axios, { AxiosResponse } from "axios";

export async function getLoginUserData() {
    try {
        const response: AxiosResponse = await Axios.get("/Users/GetCurrent");
        /* TODO - Add extra checks for valid response */
        return response.data.data;
    } catch (error) {
        throw error;
    }
}